import React, {useEffect, useState} from "react";
const HpTest = ()=>{
    return (
        <div className={"TestSection"} id={"TestSection"}>
            test
        </div>
    )
}
export default HpTest;
